import { useState, useEffect } from "react";
import {
  getPresidentList,
  getVicePresidentList,
  getRegions,
} from "../../../../api/ph-api";
import RacesPage from "../../../../../components/races/RacesPage";
import { SeoTag, CxenseParseTag } from "../../../../../components/seo/SeoTag";

export const getStaticProps = async () => {
  let presidential = await getPresidentList();
  let vPresidential = await getVicePresidentList();
  let regionList = await getRegions();

  // Add candidateColor
  presidential.results.forEach((candidate) => {
    candidate.selected = true;
    candidate.votes = "0";
    candidate.percentage = 0;
    switch (candidate.last_name.toLowerCase()) {
      case "robredo":
        candidate.color = "rgba(252, 106, 223, 1)";
        candidate.legend = "rect";
        break;
      case "marcos":
        candidate.color = "rgba(192, 36, 2, 1)";
        candidate.legend = "rectRot";
        break;
      case "pacquiao":
        candidate.color = "rgba(57, 198, 240, 1)";
        candidate.legend = "circle";
        break;
      case "domagoso":
        candidate.color = "rgba(64, 118, 255, 1)";
        candidate.legend = "rectRot";
        break;
      case "de guzman":
        candidate.color = "rgba(242, 106, 90, 1)";
        candidate.legend = "rect";
        break;
      case "lacson":
        candidate.color = "rgba(183, 125, 222, 1)";
        candidate.legend = "circle";
        break;
      case "mangondato":
        candidate.color = "rgba(72, 167, 104, 1)";
        candidate.legend = "rect";
        break;
      case "montemayor":
        candidate.color = "rgba(202, 185, 36, 1)";
        candidate.legend = "triangle";
        break;
      case "abella":
        candidate.color = "rgba(92, 161, 144, 1)";
        candidate.legend = "circle";
        break;
      case "gonzales":
        candidate.color = "rgba(197, 101, 12, 1)";
        candidate.legend = "triangle";
        break;
      default:
        candidate.color = "rgba(0, 0, 0, 1)";
        candidate.legend = "circle";
        break;
    }
  });

  vPresidential.results.forEach((candidate) => {
    candidate.selected = true;
    candidate.votes = "0";
    candidate.percentage = 0;
    switch (candidate.last_name.toLowerCase()) {
      case "pangilinan":
        candidate.color = "rgba(252, 106, 223, 1)";
        candidate.legend = "rect";
        break;
      case "duterte":
        candidate.color = "rgba(192, 36, 2, 1)";
        candidate.legend = "rectRot";
        break;
      case "atienza":
        candidate.color = "rgba(57, 198, 240, 1)";
        candidate.legend = "circle";
        break;
      case "ong":
        candidate.color = "rgba(64, 118, 255, 1)";
        candidate.legend = "rectRot";
        break;
      case "bello":
        candidate.color = "rgba(242, 106, 90, 1)";
        candidate.legend = "rect";
        break;
      case "sotto":
        candidate.color = "rgba(183, 125, 222, 1)";
        candidate.legend = "circle";
        break;
      case "serapio":
        candidate.color = "rgba(72, 167, 104, 1)";
        candidate.legend = "rect";
        break;
      case "david":
        candidate.color = "rgba(202, 185, 36, 1)";
        candidate.legend = "triangle";
        break;
      case "lopez":
        candidate.color = "rgba(92, 161, 144, 1)";
        candidate.legend = "rectRot";
        break;
      default:
        candidate.color = "rgba(0, 0, 0, 1)";
        candidate.legend = "circle";
        break;
    }
  });

  return {
    props: { presidential, vPresidential, regionList },
    revalidate: 5,
  };
};

const PresVpOfficialResult = ({ presidential, vPresidential, regionList }) => {
  const [url, setUrl] = useState("");
  const title =
    "OFFICIAL RESULTS: 2022 presidential, vice presidential election | Philippines";
  const description =
    "See official results for president and vice president based on certificates of canvass. This is based on the canvassing by the Congress sitting as the National Board of Canvassers at the House of Representatives";
  const keywords =
    "2022 Philippine elections, Philippine elections, Philippine presidential elections, Philippine vice presidential elections, Comelec, election results";
  const og_image = "https://www.rappler.com/tachyon/2022/03/ATIN-PILIPINAS.jpg";

  useEffect(() => {
    setUrl(window.location.href);
  }, []);

  return (
    <>
      <SeoTag
        title={title}
        description={description}
        keywords={keywords}
        og_image={og_image}
        twitter_og_image={og_image}
        twitter_title={title}
        twitter_description={description}
      />
      <CxenseParseTag title={title} />
      <RacesPage
        view="official-results"
        path="president-vice-president"
        presidential={presidential}
        vPresidential={vPresidential}
        regionList={regionList}
        url={url}
      />
    </>
  );
};

export default PresVpOfficialResult;
